import { CreateNote } from "./CreateNote";

export default CreateNote;
